import * as nodeRenderGraphEditor from "node-render-graph-editor/legacy/legacy";
export { nodeRenderGraphEditor };
export default nodeRenderGraphEditor;
